import { createRef, ChangeEvent, useEffect } from "react";

import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { ICreateModalidade } from "src/Contexts/comissoes/ComissoesTypes";
import { AppTextField } from "src/Pages/components/AppFormComponents/AppTextField";

export const FormModalidade = () => {
  const { valuesInputsModalidade, setValuesInputsModalidade } =
    useContextComissoes();

  const refOrigem = createRef<HTMLInputElement>();
  const handleFocusedID = () => refOrigem.current?.focus();

  useEffect(() => {
    handleFocusedID();
  }, []);

  const handleChange =
    (prop: keyof ICreateModalidade) =>
    (event: ChangeEvent<HTMLInputElement>) => {
      setValuesInputsModalidade((eventPrev) => ({
        ...eventPrev,
        [prop]: event.target.value,
      }));
    };

  return (
    <AppTextField
      fullWidth
      inputRef={refOrigem}
      label="Modalidade *"
      value={valuesInputsModalidade?.name}
      onChange={handleChange("name")}
    />
  );
};
